import { createAction, props } from '@ngrx/store';
import { ObjectSource } from 'src/app/public/common/constants/general-basic-data';
import { Conversation } from 'src/app/public/common/models/conversation.model';
import { Message } from 'src/app/public/common/models/message.model';


export class MessageActions {

    public static sendNewMessageSubmit = createAction(
        '[Message Form Component] Send message Submit',
        props <{ message: Message, objectSource: ObjectSource }> ()
    );

    public static sendNewMessageSuccess = createAction(
        '[Dealer API] Send message Success',
        props <{ conversation: Conversation, objectSource: ObjectSource }> ()
    );

    /* 
    public static replyMessageSubmit = createAction(
        '[Message Form Component] reply to Conversation Submit',
        props <{ reply: string, carId: string, conversationId: number}> ()
    );

    public static replyMessageSuccess = createAction(
        '[Dealer API] reply to Conversation Success',
        props <{ message: Message, carId: string, conversationId: number }> ()
    );

    public static fetchMessagesSubmit = createAction(
        '[Dealer Component] Fetch messages Submit'
    );

    public static fetchMessagesSuccess = createAction(
        '[Message API] Fetch messages Success',
        props <{ messages: Message[] }> ()
    );
    */
}
